import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent, SelectProps } from "@mui/material/Select";

import i18n from "~/i18n/i18next";
import { locales } from "~/i18n/settings";

import routes from "~/routes/main";

import Image from "~/core/components/Image";
import useCopy from "~/core/locale";

type LanguageSwitcherProps = SelectProps;

const languages = [
  { lang: locales.en, flag: "UK" },
  { lang: locales.ar, flag: "SAU" },
];
const LanguageSwitcher = (props: LanguageSwitcherProps) => {
  const { ...selectProps } = props;
  const { translate } = useCopy();
  const [language, setLanguage] = useState(i18n?.language);

  const setLanguageHandler = (event: SelectChangeEvent<unknown>) => {
    setLanguage(event.target.value as string);
  };

  useEffect(() => {
    // the condition to prevent calling i18next.changeLanguage on first render or on wasted renders.
    // if user select a language
    if (language !== i18n?.resolvedLanguage) {
      i18n?.changeLanguage(language);
    }
  }, [language]);
  return (
    <>
      <FormControl
        variant="outlined"
        margin="normal"
        fullWidth
        sx={{ marginY: 0 }}
      >
        <InputLabel id="language">{translate("label.language")}</InputLabel>
        <Select
          labelId="language"
          id="language"
          size="small"
          type="text"
          label={translate("label.language")}
          value={language || ""}
          onChange={setLanguageHandler}
          {...selectProps}
        >
          {languages.map(({ lang, flag }) => {
            return (
              <MenuItem key={lang} value={lang} divider>
                <Box
                  sx={{
                    display: "flex",
                    "& span": {
                      marginLeft: 0.5,
                    },
                  }}
                >
                  <Image
                    src={`${routes.flags}/${flag}.svg`}
                    width={20}
                    height={20}
                    alt="country flag"
                  />
                  <span>{`${translate(`language.name.${lang}`)}`}</span>
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
};

export default LanguageSwitcher;
